<template>
  <div id="receipt-show" style="margin-bottom: 55px">
    <b-card class="mb-5">
      <b-row>
        <b-col md="6">
          <!-- get name from router name -->
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/worksheet/">Worksheet</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
        <b-col md="6">
      <b-button v-if="model.status === 'Solved' || model.status === 'Done'"
        v-b-tooltip.hover.top
        title="Export to PDF"
        variant="info"
        @click="doExportPdf()"
        class="btn-download float-right"
        ><font-awesome-icon icon="download"
      /></b-button>
        </b-col>
      </b-row>
      <div class="border-bottom mb-3"></div>


      <div v-if="isLoading" style="z-index: 1000;">
        <div class="text-center" style="margin: 3% auto;">
          <b-spinner small type="grow" label="Small Spinner"></b-spinner>
          <b-spinner small variant="primary" type="grow" label="Small Spinner"></b-spinner>
          <b-spinner small variant="success" type="grow" label="Small Spinner"></b-spinner>
        </div>
      </div>
      <div v-else>
        <b-row>
          <!-- leftt -->
          <b-col md="6">
            <b-row>
              <b-col md="3">
                <label for="" class="labels">Worksheet Id</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="4" v-text="model.worksheetId"></b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <label for="" class="labels">Worksheet type</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="4" v-text="model.worksheetType"></b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <label for="" class="labels">Created By</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col
                md="4"
                v-text="model.createdBy.firstName + ' ' + model.createdBy.lastName"
              ></b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <label for="" class="labels">Customer</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="4" v-text="model.customer"></b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <label for="" class="labels">Customer PIC</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="4" v-text="model.customerPicName"></b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <label for="" class="labels">PIC Phone number</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="4" v-text="model.customerPicPhone"></b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <label for="" class="labels">Note</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="4" style="white-space: pre-line;" v-text="model.note"></b-col>
            </b-row>
          </b-col>
          <!-- right -->
          <b-col md="6">
            <b-row>
              <b-col md="2">
                <label for="" class="labels">Created Date</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="4" v-text="model.createdAt"></b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <label for="" class="labels">Start Date</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="4" v-text="model.worksheetStartDate"></b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <label for="" class="labels">Finish Date</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="4" v-text="model.worksheetFinishDate"></b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <label for="" class="labels">status</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="4"
                ><p>
                  <b-badge :variant="getStatusColor(model.status)">{{
                    model.status !== null ? model.status : '-'
                  }}</b-badge>
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col>
            <div class="mt-3 mb-3">
              <h4>Worksheet Description</h4>
              <table class="table-responsive mt-3 table-striped">
                <thead class="table-bordered px-3">
                  <tr>
                    <!-- <th class="text-center">No</th> -->
                    <th class="px-3">Date</th>
                    <th class="px-3">Work Subject</th>
                    <th class="px-3">Note</th>
                    <th class="px-3">Photo</th>
                  </tr>
                </thead>
                <tbody v-if="worksheetSubject.length > 0">
                  <tr v-for="(work, i) in worksheetSubject" :key="i">
                    <!-- <td width="50" class="text-center">{{ i++ }}</td> -->
                    <td width="300" class="px-3">
                      {{ work.createdAt !== null ? getDateTime(work.createdAt) : '-' }}
                    </td>
                    <td width="300" class="px-3" style="white-space: pre-line;">
                      {{ work.workSubject !== null ? work.workSubject : '-' }}
                    </td>
                    <td width="660" class="px-3" style="white-space: pre-line;">
                      {{ work.workDescription !== null ? work.workDescription : '-' }}
                    </td>
                    <td class="pointer px-3" width="120">
                      <viewer>
                        <b-row>
                          <b-col md="3">
                            <p
                              class="text-secondary text-center d-flex"
                              v-if="work.workEvidences === null"
                            >
                              <i>No Photo Submitted</i>
                            </p>
                            <b-img
                              v-else
                              :src="work.workEvidences"
                              v-b-tooltip.focus
                              class="img-responsive border-radius"
                              width="60"
                              height="60"
                            />
                          </b-col>
                        </b-row>
                      </viewer>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <p><i>no data found</i></p>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
        <b-button class="mt-3" @click="goBack()" variant="secondary"
          ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
        >
        <b-button
          v-if="model.status === 'Solved'"
          @click="showModal()"
          class="mt-3 float-right"
          variant="success"
          ><font-awesome-icon icon="check"></font-awesome-icon> Done</b-button
        >
      </div>
    </b-card>
    <b-modal ref="my-modal" centered hide-footer title="Done Worksheet ?">
      <form v-on:submit.prevent="doSubmit">
        <b-button class="mt-3" variant="secondary" @click="hideModal"
          ><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button
        >
        <b-button class="mt-3 float-right" variant="success" type="submit"
          ><font-awesome-icon icon="check"></font-awesome-icon> Accept
        </b-button>
      </form>
    </b-modal>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vue from 'vue';
Vue.use(Viewer);

export default {
  data() {
    return {
      i: 1,
      isLoading: false,
      apiUrl: {
        worksheet: window.AppConfig.apiUrl + 'worksheet',
        worksheetStatus: window.AppConfig.apiUrl + 'worksheet-status',
        worksheetExportPdf: window.AppConfig.apiUrl + 'worksheet-export-pdf'
      },
      formData: {
        worksheet: null,
        status: 'Done',
      },
      model: {
        ticketId: null,
        worksheetId: null,
        worksheetStartDate: null,
        worksheetFinishDate: null,
        status: null,
        note: null,
        worksheetPic: null,
        counter: null,
        customerPicSignatures: null,
        customerPicName: null,
        customerPicPhone: null,
        createdAt: null,
        updatedAt: null,
        uuid: null,
        account: {
          uuid: null,
          name: null,
          currency: null,
          timezone: null,
          locale: null,
          address: null,
          city: null,
          state: null,
        },
        createdBy: {
          firstName: '',
          lastName: '',
        },
        customer: {
          uuid: null,
          name: null,
          salesType: null,
          phone: null,
          address: null,
        },
        worksheetType: null,
      },
      worksheetSubject: [],
    };
  },

  mounted() {
    this.getDetailsWorksheet();
  },

  methods: {
    getDetailsWorksheet() {
      this.isLoading = true;
      this.$http
        .get(this.apiUrl.worksheet + '/' + this.$route.params.uuid)
        .then((response) => {
          this.model.ticketId = response.data.ticketId !== null ? response.data.ticketId : '-';
          this.model.worksheetId =
            response.data.worksheetId !== null ? response.data.worksheetId : '-';
          this.model.worksheetStartDate =
            response.data.worksheetStartDate !== null
              ? this.getDateTime(response.data.worksheetStartDate)
              : '-';
          this.model.worksheetFinishDate =
            response.data.worksheetFinishDate !== null
              ? this.getDateTime(response.data.worksheetFinishDate)
              : '-';
          this.model.status = response.data.status !== null ? response.data.status : '-';
          this.model.note = response.data.note !== null ? response.data.note : '-';
          this.model.worksheetPic =
            response.data.worksheetPic !== null ? response.data.worksheetPic : '-';
          this.model.counter = response.data.counter !== null ? response.data.counter : '-';
          this.model.customer = response.data.customer !== null ? response.data.customer.name : '-';
          this.model.customerPicSignatures =
            response.data.customerPicSignatures !== null
              ? response.data.customerPicSignatures
              : '-';
          this.model.customerPicName =
            response.data.customerPicName !== null ? response.data.customerPicName : '-';
          this.model.customerPicPhone =
            response.data.customerPicPhone !== null ? response.data.customerPicPhone : '-';
          this.model.createdAt =
            response.data.createdAt !== null ? this.getDateTime(response.data.createdAt) : '-';
          this.model.updatedAt = response.data.updatedAt !== null ? response.data.updatedAt : '-';
          this.model.account = response.data.account !== null ? response.data.account : '-';
          this.model.worksheetType =
            response.data.worksheetType !== null ? response.data.worksheetType.name : '-';
          this.model.createdBy = response.data.createdBy;
          this.model.uuid = response.data.uuid !== null ? response.data.uuid : '-';
          this.worksheetSubject = [];
          if (response.data.worksheetSubject !== null) {
            response.data.worksheetSubject.forEach((data) => {
              this.worksheetSubject.push(data);
            });
          }
          setTimeout(() => {
            this.isLoading = false;
          }, 1000);
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    showModal() {
      this.formData.worksheet = this.model.uuid;
      this.formData.status = 'Done';
      this.$validator.reset();
      this.$refs['my-modal'].show();
    },
    hideModal() {
      this.$refs['my-modal'].hide();
    },

    doSubmit() {
      if (this.formData.worksheet !== null) {
        this.$http
          .post(this.apiUrl.worksheetStatus, {
            worksheet: this.formData.worksheet,
            status: this.formData.status,
          })
          // eslint-disable-next-line no-unused-vars
          .then((response) => {
            this.$store.dispatch('notification/success', 'Worksheet Status has been updated.');
            this.getDetailsWorksheet()
            this.hideModal();
          })
          .catch((error) => {
            this.$store.dispatch('notification/error', error);
          });
      } else {
        console.log('gagal');
      }
    },

    doExportPdf(){
      let url = this.apiUrl.worksheetExportPdf + '?worksheet_uuid=' + this.$route.params.uuid
      window.open(url)
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('LLL');
      } else {
        return '-';
      }
    },

    getStatusColor(val) {
      switch (val) {
        case 'Created':
          return 'secondary';
          // eslint-disable-next-line no-unreachable
          break;
        // eslint-disable-next-line no-unreachable
        case 'Progress':
          return 'warning';
          // eslint-disable-next-line no-unreachable
          break;
        case 'In Progress':
          return 'warning';
          // eslint-disable-next-line no-unreachable
          break

        case 'Solved':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break
          
        case 'Done':
          return 'primary';
          // eslint-disable-next-line no-unreachable
          break;
      }
    },
    goBack() {
      window.goBack(this);
    },
  },
};
</script>
